import { Link } from 'react-router-dom';
import ListItemWrapper from '../../ListItemWrapper';
import Column from '../../Column';
import React, { useContext, useEffect, useState } from 'react';
import MetricUsageLookupContext from '../../../../../contexts/MetricUsageLookupContext';
import Button from '../../../../../kingpin/atoms/Button';
import UsagePopup from '../../../Metrics/MetricContextMenu/MergeDuplicateMetrics/UsagePopup';
import usePopup from '../../../../../hooks/usePopup';
import MetricsContext from '../../../../../contexts/MetricsContext';

const FieldUsageItem = ({
  link,
  name,
  category,
  metricId,
}: {
  link: string;
  name: string;
  category?: string;
  metricId?: string;
}) => {
  const { metricLookup } = useContext(MetricUsageLookupContext);
  const { allMetrics } = useContext(MetricsContext);
  const [metricUsage, setMetricUsage] =
    useState<FleetOps.MetricLookupResults>();
  const [metric, setMetric] = useState<Metrics.NormalMetric>();
  const { isOpen, open, close } = usePopup();

  useEffect(() => {
    if (metricId) {
      setMetricUsage(metricLookup[metricId]);
      setMetric(allMetrics.find((m) => m.id === metricId));
    }
  }, [allMetrics, metric, metricId, metricLookup, metricUsage]);
  return (
    <ListItemWrapper style={{ height: 'auto', minHeight: 56, padding: 12 }}>
      <div style={{ flex: 1 }}>
        <Column style={{ minHeight: 0 }}>
          <Link
            style={{ fontSize: 12, maxWidth: 200 }}
            target={'_blank'}
            to={link}
          >
            {name}
          </Link>
        </Column>
        {category && (
          <Link
            style={{ marginTop: 8, display: 'block', fontSize: 12 }}
            to={link}
          >
            {category}
          </Link>
        )}
      </div>
      {metricUsage && metric && (
        <>
          <Button
            label={`Usages (${metricUsage?.usageCount || 0})`}
            size={'Small'}
            icon={'info'}
            testId={`show-usages-${metricId}`}
            onClick={open}
            type={'Secondary'}
          />
          <UsagePopup isOpen={isOpen} close={close} metric={metric} />
        </>
      )}
    </ListItemWrapper>
  );
};

export default FieldUsageItem;
